(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7735],{

/***/ 95913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9605);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84838);
/* harmony import */ var _components_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56090);
/* harmony import */ var _components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);
/* eslint-disable @next/next/next-script-for-ga */







var __N_SSP = true;
function Page(_ref) {
  var _widgetData$metadata, _widgetData$metadata2, _widgetData$metadata3, _widgetData$metadata4;

  var data = _ref.data;
  var widgetData = JSON.parse(data);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_common__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .Ar, {
    navbar: widgetData === null || widgetData === void 0 ? void 0 : widgetData.menu,
    footer: widgetData === null || widgetData === void 0 ? void 0 : widgetData.footer,
    metadata: widgetData === null || widgetData === void 0 ? void 0 : widgetData.metadata,
    breadcrumbs: widgetData === null || widgetData === void 0 ? void 0 : widgetData.breadcrumbs,
    appDownload: widgetData === null || widgetData === void 0 ? void 0 : widgetData.app_download_widget,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("title", {
        children: (widgetData === null || widgetData === void 0 ? void 0 : (_widgetData$metadata = widgetData.metadata) === null || _widgetData$metadata === void 0 ? void 0 : _widgetData$metadata.title) || (widgetData === null || widgetData === void 0 ? void 0 : widgetData.name)
      }), (widgetData === null || widgetData === void 0 ? void 0 : (_widgetData$metadata2 = widgetData.metadata) === null || _widgetData$metadata2 === void 0 ? void 0 : _widgetData$metadata2.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("meta", {
        name: "description",
        content: widgetData.metadata.description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("meta", {
        name: "keywords",
        content: (widgetData === null || widgetData === void 0 ? void 0 : (_widgetData$metadata3 = widgetData.metadata) === null || _widgetData$metadata3 === void 0 ? void 0 : _widgetData$metadata3.keywords) || (widgetData === null || widgetData === void 0 ? void 0 : (_widgetData$metadata4 = widgetData.metadata) === null || _widgetData$metadata4 === void 0 ? void 0 : _widgetData$metadata4.title) || 'Bakcell'
      }), ' ']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_2__/* .Breadcrumbs */ .Oo, {
      data: widgetData === null || widgetData === void 0 ? void 0 : widgetData.breadcrumbs
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      widgets: widgetData === null || widgetData === void 0 ? void 0 : widgetData.widgets
    })]
  });
}

/***/ }),

/***/ 89884:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esim",
      function () {
        return __webpack_require__(95913);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5443,1255,7847,6913,8922,5403,2030,9774,2888,179], function() { return __webpack_exec__(89884); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);